var toObject = require('../internals/to-object');

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/okta-idx-js/node_modules/core-js/internals/has.js
// module id = 163
// module chunks = 0